import React, { useLayoutEffect } from 'react';

import { useTrackingView } from '../shared/hooks/useTrackingView';
import { useAptiveAuth } from '../shared/hooks/AptiveAuth';
import { isUsingMagicLinkAuthen } from '../helpers';
import { LEGACY_PORTAL_URL } from '../constants/legacy';

interface AuthPageProps {
  company?: string;
}

const AuthPage: React.FC<AuthPageProps> = () => {
  const { loginWithRedirect } = useAptiveAuth();
  useTrackingView();

  useLayoutEffect(() => {
    const isMagicLinkFlow = isUsingMagicLinkAuthen();

    if (isMagicLinkFlow) {
      loginWithRedirect?.();
      return;
    }

    window.location.replace(LEGACY_PORTAL_URL);
  }, [loginWithRedirect]);

  return null;
};

export default AuthPage;
